import { Box, Grid, Typography } from "@mui/material";
import { EvaluationDetails } from "../Icon";
import makeStyles from "@mui/styles/makeStyles";
import { useEffect, useState } from "react";

const useStyles = makeStyles((theme) => ({
  mainTypography: {
    fontSize: 17,
    fontWeight: 600,
    color: "#4B4B4B",
  },
  secondTypography: {
    fontSize: 14,
    fontWeight: 600,
    color: "#979797",
  },
  typography: {
    fontSize: 14,
    fontWeight: 400,
    color: "#4B4B4B",
  },
  icon: {
    marginTop: 10,
  },
  parentContainer: {
    "@media print": {
      display: "block",
    },
  },
}));

const DetailedEvaluation = (props) => {
  const classes = useStyles();
  const { proposalReferee } = props;
  const [detailedEvaluation, setDetailedEvaluation] = useState();

  useEffect(() => {
    if (proposalReferee === null || proposalReferee === undefined) return;
    setDetailedEvaluation(proposalReferee.detailedEvaluation);
  }, [proposalReferee]);

  return (
    <Box margin={3}>
      <Grid container spacing={1} className={classes.parentContainer}>
        <Grid item xs={1}>
          <EvaluationDetails className={classes.icon} />
        </Grid>
        <Grid item xs={11}>
          <Box textAlign="left">
            <Typography variant="subtitle2" className={classes.mainTypography}>
              Detailed Evaluation
            </Typography>
            <Typography
              variant="subtitle2"
              className={classes.secondTypography}
            >
              Sent to the applicant
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Typography className={classes.typography}>
            <p>{detailedEvaluation}</p>
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DetailedEvaluation;
